import { HTTPClientInterface, HTTPRequest } from '@shared/core/HTTPClientInterface';
import { buildURL, SystemURL } from './URLCatalog';
import { Role, RoleAssignment } from '@models/Permissions';

export class RolesService {
    private httpClient: HTTPClientInterface;

    constructor(httpClient: HTTPClientInterface) {
        this.httpClient = httpClient;
    }

    async createRole(orgId: string, roleName: string): Promise<Role> {
        const request = new HTTPRequest();
        request.url = buildURL(SystemURL.Roles.postCreateRole, { org_id: orgId });
        request.method = 'POST';
        request.body = { name: roleName, permissions: [] };
        const response = await this.httpClient.execute(request);
        return response.result;
    }

    async getRoles(orgId: string): Promise<Role[]> {
        const request = new HTTPRequest();
        request.url = buildURL(SystemURL.Roles.getRoles, { org_id: orgId });
        request.method = 'GET';
        const response = await this.httpClient.execute(request);
        return response.result;
    }

    async getAllAssignments(orgId: string): Promise<RoleAssignment[]> {
        const request = new HTTPRequest();
        request.url = buildURL(SystemURL.Roles.getAllAssignments, { org_id: orgId });
        request.method = 'GET';
        const response = await this.httpClient.execute(request);
        return response.result;
    }

    async assignRoleToUser(orgId: string, roleId: string, userId: string): Promise<void> {
        const request = new HTTPRequest();
        request.url = buildURL(SystemURL.Roles.postAssignRoleToUser, { org_id: orgId, role_id: roleId, user_id: userId });
        request.method = 'POST';
        await this.httpClient.execute(request);
    }

    async deleteRole(orgId: string, roleId: string): Promise<void> {
        const request = new HTTPRequest();
        request.url = buildURL(SystemURL.Roles.deleteRole, { org_id: orgId, role_id: roleId });
        request.method = 'DELETE';
        await this.httpClient.execute(request);
    }

    async updateRolePermissions(orgId: string, roleId: string, permissions: any[]): Promise<void> {
        const request = new HTTPRequest();
        request.url = buildURL(SystemURL.Roles.putUpdateRolePermissions, { org_id: orgId, role_id: roleId });
        request.method = 'PUT';
        request.body = { permissions };
        await this.httpClient.execute(request);
    }
}